import { useEffect, useState } from 'react';
import { Button, Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import classNames from 'classnames';

import isFunction from 'Lib/utilities/isFunction';

export function useFilter(props, loadValue = null, onClear) {
    const [value, setValue] = useState(null);
    const [isOpen, setIsOpen] = useState(null);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleCancel = () => {
        setIsOpen(false);
    };

    const close = () => {
        setIsOpen(false);
    };

    const setFilterValue = (name, value) => {
        props.context.setFilterValue(name, value);
    };

    const setFilterValues = values => {
        props.context.setFilterValues(values);
    };

    useEffect(() => {
        if (loadValue) {
            loadValue();
        }
    }, []);

    const renderMenuButtons = ({ showUpdate = true, showClear = true, showCancel = true, form, handleCancel, handleClear }) => (
        <div className="searchable-list-filter-menu-buttons" style={{ position: 'sticky', bottom: '0', backgroundColor: 'white', zIndex: '1' }}>
            {showUpdate && (
                <Button size="sm" color="primary" type="submit">
                    Update
                </Button>
            )}
            {showClear && (
                <Button size="sm" color="link" type="button" onClick={() => handleClear(form)}>
                    Clear
                </Button>
            )}
            {showCancel && (
                <Button size="sm" color="link" type="button" onClick={() => handleCancel(form)}>
                    Cancel
                </Button>
            )}
        </div>
    );

    const render = (menu, label) => {
        if (isFunction(menu)) {
            menu = menu();
        }

        if (label) {
            if (isFunction(label)) {
                label = label();
            }
        }

        const FilterLabel = () => {
            if (value?.label) {
                return <div className="searchable-list-filter-menu-item-button-value">{value.label}</div>;
            } else if (Array.isArray(value) && value[0].label) {
                return (
                    <div className="searchable-list-filter-menu-item-button-value">
                        {value.map((v, index) => <span key={index}>{v.label}</span>).reduce((accumulator, current) => [accumulator, ', ', current])}
                    </div>
                );
            } else return null;
        };

        return (
            <Dropdown isOpen={isOpen} toggle={handleToggle} direction={props.label === 'Transaction Type' ? 'left' : null}>
                <DropdownToggle tag="div" className={classNames('searchable-list-filter-menu-item-button', { 'has-value': value })}>
                    <div className="searchable-list-filter-menu-item-button-text">
                        {label ? (
                            <div className="searchable-list-filter-menu-item-button-label">{label}</div>
                        ) : (
                            <>
                                <div className="searchable-list-filter-menu-item-button-label">{props.label}</div>
                                <FilterLabel />
                            </>
                        )}
                        {props.isMore && (
                            <div
                                className="searchable-list-filter-menu-item-button-remove"
                                onClick={() => {
                                    if (onClear) onClear();
                                    props.context.removeMoreFilter(props.name);
                                }}
                            >
                                &times;
                            </div>
                        )}
                        {props.isTemp && (
                            <div
                                className="searchable-list-filter-menu-item-button-remove"
                                onClick={() => {
                                    props.context.removeTempFilter(props.name);
                                }}
                            >
                                &times;
                            </div>
                        )}
                    </div>
                </DropdownToggle>
                <DropdownMenu>{menu}</DropdownMenu>
            </Dropdown>
        );
    };

    return {
        value,
        isOpen,
        setValue,
        setIsOpen,
        handleToggle,
        handleCancel,
        close,
        render,
        renderMenuButtons,
        setFilterValue,
        setFilterValues
    };
}

export default useFilter;
